import React from 'react';
import styles from './NotFoundPage.module.css';

interface NotFoundPageProps {}

const NotFoundPage: React.FC<NotFoundPageProps> = () => {
    return (
        <>
    <div className={styles._404_page}>
      <div className={styles.error_pop_up}>
        <div className={styles.illustration}>
          <div className={styles.shadow}></div>
          <div className={styles.content}>
            <svg
              className={styles.sentiment_very_dissatisfied}
              width="56"
              height="57"
              viewBox="0 0 56 57"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_593_34774"
                style={{maskType: 'alpha'}}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="56"
                height="57"
              >
                <rect
                  x="8.67578"
                  y="0.570312"
                  width="48"
                  height="48"
                  transform="rotate(10.2955 8.67578 0.570312)"
                  fill="#D9D9D9"
                />
              </mask>
              <g mask="url(#mask0_593_34774)">
                <path
                  d="M27.4657 31.4151C25.2355 31.01 23.0956 31.2735 21.0461 32.2055C18.9965 33.1375 17.3741 34.5622 16.1788 36.4794L36.2504 40.1254C35.8058 37.9103 34.7881 36.0061 33.1972 34.4128C31.6064 32.8194 29.6958 31.8202 27.4657 31.4151ZM19.7371 26.9621L22.277 25.2891L23.9679 27.7307L26.4094 26.0398L24.7185 23.5983L27.1779 21.809L25.487 19.3675L23.0455 21.0584L21.2563 18.599L18.8148 20.2899L20.4877 22.8298L18.0462 24.5206L19.7371 26.9621ZM32.0358 29.1962L34.4773 27.5053L36.2666 29.9647L38.7081 28.2739L37.0172 25.8323L39.4766 24.0431L37.7858 21.6016L35.2459 23.2746L33.555 20.8331L31.1135 22.5239L32.7865 25.0638L30.345 26.7547L32.0358 29.1962ZM24.4273 48.1414C21.7052 47.6469 19.2409 46.6657 17.0344 45.1977C14.8279 43.7297 13 41.9494 11.5507 39.8566C10.1014 37.7639 9.07765 35.4266 8.47945 32.8448C7.88126 30.263 7.8294 27.611 8.32387 24.8889C8.81834 22.1668 9.79958 19.7025 11.2676 17.496C12.7356 15.2895 14.5159 13.4616 16.6086 12.0123C18.7014 10.563 21.0386 9.53922 23.6205 8.94103C26.2023 8.34283 28.8542 8.29097 31.5764 8.78544C34.2985 9.27992 36.7628 10.2612 38.9693 11.7291C41.1758 13.1971 43.0037 14.9775 44.453 17.0702C45.9023 19.1629 46.9261 21.5002 47.5242 24.082C48.1224 26.6638 48.1743 29.3158 47.6798 32.0379C47.1854 34.7601 46.2041 37.2244 44.7361 39.4309C43.2681 41.6373 41.4878 43.4652 39.3951 44.9146C37.3023 46.3639 34.9651 47.3876 32.3832 47.9858C29.8014 48.584 27.1495 48.6359 24.4273 48.1414ZM25.1422 44.2058C29.537 45.0041 33.5364 44.1552 37.1406 41.6592C40.7447 39.1632 42.9459 35.7178 43.7442 31.323C44.5425 26.9283 43.6937 22.9288 41.1976 19.3247C38.7016 15.7206 35.2562 13.5193 30.8615 12.721C26.4667 11.9227 22.4673 12.7716 18.8631 15.2676C15.259 17.7637 13.0578 21.2091 12.2595 25.6038C11.4612 29.9986 12.31 33.998 14.8061 37.6021C17.3021 41.2063 20.7475 43.4075 25.1422 44.2058Z"
                  fill="#7654E8"
                />
              </g>
            </svg>
          </div>
        </div>
        <div className={styles.content2}>
          <div className={styles.title}>This page is unavailable</div>
          <div className={styles.text}>
            You don’t have access to this page or it doesn’t exist anymore.
          </div>
        </div>
        <div className={styles.button}>
          <div className={styles.text2}>Go back</div>
        </div>
      </div>
      <div className={styles.header}>
        <div className={styles.logo}>
          <img className={styles.logo_icon} src="/images/NotFoundPage/logo-icon0.png" />
          <div className={styles.brand_name}>AI builder</div>
        </div>
        <div className={styles.breadcrumbs}>
          <div className={styles.step_1}>
            <div className={styles.number_of_the_step}>
              <div className={styles.number}>1</div>
            </div>
            <div className={styles.text3}>Short Brief</div>
          </div>
          <svg
            className={styles.chevron_right}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.74408 6.90814C7.41864 7.23358 7.41864 7.76121 7.74408 8.08665L9.65482 9.9974L7.74408 11.9081C7.41864 12.2336 7.41864 12.7612 7.74408 13.0867C8.06951 13.4121 8.59715 13.4121 8.92259 13.0867L11.4226 10.5867C11.748 10.2612 11.748 9.73358 11.4226 9.40814L8.92259 6.90814C8.59715 6.5827 8.06951 6.5827 7.74408 6.90814Z"
              fill="#737373"
            />
          </svg>

          <div className={styles.step_2}>
            <div className={styles.number_of_the_step2}>
              <div className={styles.number}>2</div>
            </div>
            <div className={styles.text4}>Edit</div>
          </div>
          <svg
            className={styles.chevron_right2}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.74408 6.90814C7.41864 7.23358 7.41864 7.76121 7.74408 8.08665L9.65482 9.9974L7.74408 11.9081C7.41864 12.2336 7.41864 12.7612 7.74408 13.0867C8.06951 13.4121 8.59715 13.4121 8.92259 13.0867L11.4226 10.5867C11.748 10.2612 11.748 9.73358 11.4226 9.40814L8.92259 6.90814C8.59715 6.5827 8.06951 6.5827 7.74408 6.90814Z"
              fill="#737373"
            />
          </svg>

          <div className={styles.step_3}>
            <div className={styles.number_of_the_step2}>
              <div className={styles.number}>3</div>
            </div>
            <div className={styles.text4}>Preview and Publish</div>
          </div>
        </div>
        <div className={styles.actions}>
          <div className={styles.language_selection}>
            <svg
              className={styles.language}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_1000_5260"
                style={{maskType: 'alpha'}}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_1000_5260)">
                <path
                  d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z"
                  fill="#1C1B1F"
                />
              </g>
            </svg>

            <div className={styles.language3}>English</div>
          </div>
          <div className={styles.account}>
            <img className={styles.avatar} src="/images/NotFoundPage/avatar0.png" />
            <div className={styles.text4}>Account</div>
            <svg
              className={styles.chevron_down}
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.6727 8.15814C12.3473 7.8327 11.8196 7.8327 11.4942 8.15814L9.58345 10.0689L7.6727 8.15814C7.34727 7.8327 6.81963 7.8327 6.49419 8.15814C6.16876 8.48358 6.16876 9.01121 6.49419 9.33665L8.99419 11.8367C9.31963 12.1621 9.84727 12.1621 10.1727 11.8367L12.6727 9.33665C12.9981 9.01121 12.9981 8.48358 12.6727 8.15814Z"
                fill="#262626"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className={styles.help_resources}>
        <div className={styles.hint}>
          <div className={styles.text_wrapper}>
            <div className={styles.text5}>Help &amp; Resources</div>
          </div>
          <svg
            className={styles.polygon_7}
            width="15.999999046325684"
            height="16.000001907348633"
          ></svg>
        </div>
      
      </div>
    </div>
  </>
    );
};

export default NotFoundPage;
